import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Section, Eyebrow, H2, Lead, GlassCard } from "../components/site/Primitives";
import { Mail, MapPin, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function Contact() {
  const [params] = useSearchParams();
  const topic = params.get("topic") || "general";
  const [f, setF] = useState({ name: "", email: "", phone: "", subject: "", message: "", topic });
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/contact", f); toast.success("Message received. We'll respond within 1 business day.");
      setF({ ...f, name: "", email: "", phone: "", subject: "", message: "" });
    } catch { toast.error("Could not send message."); }
  };

  return (
    <div>
      <Section className="pt-40">
        <Eyebrow>Contact 220 Inc.</Eyebrow>
        <H2 className="max-w-3xl">Tell us how we can help.</H2>
        <Lead className="mt-6">General inquiries, investor questions, partnerships, careers, or press — we respond within one business day.</Lead>
      </Section>

      <Section className="pt-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4 space-y-6">
            <GlassCard className="p-6">
              <Mail className="text-gold mb-3" />
              <div className="font-display text-lg">Email</div>
              <div className="text-white/65 text-sm mt-1">
                <div>Travis.McGruder@220inc.com</div>
                <div className="text-white/45 text-xs mt-2">Backup · build.the.empire220@gmail.com</div>
              </div>
            </GlassCard>
            <GlassCard className="p-6">
              <MapPin className="text-gold mb-3" />
              <div className="font-display text-lg">Headquarters</div>
              <div className="text-white/65 text-sm">Columbus, GA · Phenix City, AL</div>
            </GlassCard>
            <div className="text-[11px] uppercase tracking-[0.25em] text-white/50">
              Travis R. McGruder · Founder &amp; CEO, 220 Inc.
            </div>
          </div>
          <form onSubmit={submit} className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-5" data-testid="contact-form">
            <I label="Name *" required value={f.name} onChange={(e) => set("name", e.target.value)} />
            <I label="Email *" type="email" required value={f.email} onChange={(e) => set("email", e.target.value)} />
            <I label="Phone" value={f.phone} onChange={(e) => set("phone", e.target.value)} />
            <S label="Topic" value={f.topic} onChange={(e) => set("topic", e.target.value)} options={[
              { v: "general", l: "General" }, { v: "investor", l: "Investor" }, { v: "partner", l: "Partnership" },
              { v: "consult", l: "Consultation" }, { v: "press", l: "Press" }, { v: "veteran-housing", l: "Veteran Housing" },
            ]} />
            <label className="block md:col-span-2">
              <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">Subject</span>
              <input className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" value={f.subject} onChange={(e) => set("subject", e.target.value)} />
            </label>
            <label className="block md:col-span-2">
              <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">Message *</span>
              <textarea required rows={6} className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" value={f.message} onChange={(e) => set("message", e.target.value)} />
            </label>
            <div className="md:col-span-2"><button type="submit" className="btn-primary" data-testid="contact-submit">Send Message <ArrowRight size={14} /></button></div>
          </form>
        </div>
      </Section>
    </div>
  );
}

function I({ label, ...props }) {
  return (
    <label className="block">
      <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">{label}</span>
      <input className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" {...props} />
    </label>
  );
}
function S({ label, options, ...props }) {
  return (
    <label className="block">
      <span className="block text-xs uppercase tracking-[0.18em] text-white/50 mb-2">{label}</span>
      <select className="w-full bg-[#0e0e10] border border-white/10 px-3 py-3 text-white text-sm focus:outline-none focus:border-gold" {...props}>
        {options.map((o) => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </label>
  );
}
